export class ContractPhoto {
    id?: number
    uri: string
    created_at: string
    type?: string
    gps?: { type: string, coordinates: number[] }
    constructor(id: number, uri: string, created_at?: string, type?: string, gps?: { type: string, coordinates: number[] }) {
        this.id = id
        this.uri = uri
        this.created_at = created_at
        this.type = type
        this.gps = gps
    }

    getCoordinates(): number[] | undefined {
        return this.gps?.coordinates
    }

    isWeightReceipt() {
        return this.type === 'weight_receipt' || this.type === 'receipt'
    }

    isSortationTicket() {
        return this.type === 'sortation_ticket'
    }

    isFruitWhole() {
        return this.type === 'fruit_whole' || this.type === 'fruit_pile'
    }

    isFruitSingle() {
        return this.type === 'fruit_single' || this.type === 'fruit_bunch' || this.type === "seller_fruit_pile"
    }

    isFruit() {
        return this.isFruitSingle() || this.isFruitWhole()
    }
}

export function buildContractPhoto(p: any): ContractPhoto {
    return new ContractPhoto(p.id, p.uri, p.created_at ?? p.createdAt, p.type, p.gps)
}

// The last photo taken wins, so we keep the biggest id.
export function latestPhoto(photos: ContractPhoto[]): ContractPhoto | undefined {
    return [...photos].sort((p, p1) => (p1.id ?? 0) - (p.id ?? 0)).at(0)
}

// Shared by every ContractInterface implementation: the latest weight receipt
// followed by the latest sortation ticket.
export function buildReceiptPhotos(photos: ContractPhoto[] | undefined): ContractPhoto[] {
    const all = photos ?? []
    const weightReceipt = latestPhoto(all.filter(p => p.isWeightReceipt()))
    const sortationTicket = latestPhoto(all.filter(p => p.isSortationTicket()))
    const res: ContractPhoto[] = []
    if (weightReceipt) {
        res.push(weightReceipt)
    }
    if (sortationTicket) {
        res.push(sortationTicket)
    }
    return res
}